// App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import PrivacyPolicy from "./PrivacyPolicy";
import HelpCenter from "./HelpCenter";
import HardwareWalletGuide from "./HardwareWalletGuide";
import WarrantySupport from "./WarrantySupport";
import Community from "./Community";
import ProductPage from "./ProductPage";
import Likkim from "./Likkim";
import SideCart from "./SideCart"; // 添加侧边购物车组件

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const addToCart = (item) => {
    setCartItems((prev) => [...prev, item]);
    setIsCartOpen(true);
  };

  return (
    <Router>
      <SideCart
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cartItems={cartItems}
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/buy-likkim"
          element={<ProductPage addToCart={addToCart} />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route
          path="/hardware-wallet-guide"
          element={<HardwareWalletGuide />}
        />
        <Route path="/warrantysupport" element={<WarrantySupport />} />
        <Route path="/community" element={<Community />} />
        <Route path="/likkim" element={<Likkim addToCart={addToCart} />} />
      </Routes>
    </Router>
  );
}

export default App;
